import { getIdpLegalAgreements } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { DoseSpotClinicianAgreementT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';
import { logger } from '@/shared';

/**
 * Fetch the IDP legal agreements for the authenticated user.
 */
export async function fetchIdpLegalAgreements(
  signal?: AbortSignal
): Promise<DoseSpotClinicianAgreementT[]> {
  const config = await createLotusRequestConfig({ signal });
  const response = await getIdpLegalAgreements(config);
  const data = lotusHealthZod.getIdpLegalAgreementsResponse.parse(
    response.data
  ) as DoseSpotClinicianAgreementT[];

  logger.info('dosespot.idp.fetchLegalAgreements', {
    source: 'entities/dosespot-idp/api',
    agreementCount: data.length,
  });

  return data;
}
